(function () {
  function ready() {
    function restoreMoneyValues() {
      document.querySelectorAll('[data-money-cents]').forEach(function (value) {
        if (value.textContent.trim()) return;
        var cents = Number(value.dataset.moneyCents);
        if (!Number.isFinite(cents)) return;
        var currency = value.dataset.moneyCurrency || 'USD';
        value.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency }).format(cents / 100);
      });
    }
    restoreMoneyValues();
    window.addEventListener('load', restoreMoneyValues);
    setTimeout(restoreMoneyValues, 500);
    document.querySelectorAll('.mobile-menu-button').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = document.querySelector('.mobile-panel');
        if (!panel) return;
        var open = panel.classList.toggle('open');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        button.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
      });
    });
    document.querySelectorAll('.nav-group > button').forEach(function (button) {
      button.addEventListener('click', function () {
        var dropdown = button.nextElementSibling;
        if (!dropdown) return;
        var wasOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.nav-group > button').forEach(function (otherButton) {
          var otherDropdown = otherButton.nextElementSibling;
          if (otherDropdown) otherDropdown.classList.remove('open');
          otherButton.setAttribute('aria-expanded', 'false');
        });
        var open = !wasOpen;
        dropdown.classList.toggle('open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.querySelectorAll('.carousel-side.previous,.starter-side.previous,.related-arrow.previous').forEach(function (button) {
      button.addEventListener('click', function () {
        var track = button.parentElement.querySelector('.quote-track,.starter-track,.related-track');
        if (!track) return;
        if (track.classList.contains('starter-track') && track.scrollLeft <= 4) {
          track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        }
      });
    });
    document.querySelectorAll('.carousel-side.next,.starter-side.next,.related-arrow.next').forEach(function (button) {
      button.addEventListener('click', function () {
        var track = button.parentElement.querySelector('.quote-track,.starter-track,.related-track');
        if (!track) return;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (track.classList.contains('starter-track') && atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        }
      });
    });
    document.querySelectorAll('[data-cart-addon]').forEach(function (button) {
      button.addEventListener('click', function () {
        var status = button.parentElement.querySelector('[data-cart-addon-status]');
        var originalLabel = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        if (status) status.textContent = '';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to add this download.');
          button.textContent = 'Added';
          if (status) status.textContent = 'The recipe download was added to your cart.';
          window.location.reload();
        }).catch(function () {
          button.disabled = false;
          button.textContent = originalLabel;
          if (status) status.textContent = 'We could not add the download. Please try again.';
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();

(function(){function formatCollectionPrices(){document.querySelectorAll('.simple-collection-page [data-money-cents]').forEach(function(price){var cents=Number(price.dataset.moneyCents),currency=price.dataset.moneyCurrency||'USD',output=price.querySelector('.money')||price;if(!Number.isFinite(cents))return;output.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency,minimumFractionDigits:cents%100===0?0:2,maximumFractionDigits:2}).format(cents/100)})}function ready(){formatCollectionPrices();window.addEventListener('load',formatCollectionPrices);setTimeout(formatCollectionPrices,500);setTimeout(formatCollectionPrices,1800)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready()})();

(function(){function formatAllCollectionPrices(){document.querySelectorAll('.collection-page [data-money-cents]').forEach(function(price){var cents=Number(price.dataset.moneyCents),currency=price.dataset.moneyCurrency||'USD',output=price.querySelector('.money')||price;if(!Number.isFinite(cents))return;output.textContent=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:currency,minimumFractionDigits:cents%100===0?0:2,maximumFractionDigits:2}).format(cents/100)})}function ready(){formatAllCollectionPrices();window.addEventListener('load',formatAllCollectionPrices);setTimeout(formatAllCollectionPrices,500);setTimeout(formatAllCollectionPrices,1800)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready()})();

(function(){function f(){document.querySelectorAll(".collection-page [data-collection-price]").forEach(function(p){var c=Number(p.dataset.collectionPrice);if(!Number.isFinite(c))return;p.textContent=new Intl.NumberFormat(document.documentElement.lang||"en-US",{style:"currency",currency:"USD",minimumFractionDigits:c%100===0?0:2,maximumFractionDigits:2}).format(c/100);});}f();window.addEventListener("load",f);setTimeout(f,500);setTimeout(f,1800);}());
